import React, {useState} from 'react'
import { todayRegistersQuery, sitesQueryByIds, clientsQueryByIds, severeNonConformitiesQuery, substituteReasonsQuery, emailTemplatesQuery } from '../lib/data'
import { _FETCH} from '../lib/patches'
import Loading from './Loading'
import { useQuery } from '@tanstack/react-query'
import { positionNumber, siteAddress, addValueForDropdown, convertRichEditorDynamicData, sortByLabel, timePassedTranslated, errorAlert } from '../lib/utils'
import VisDiv from './frontend_components/VisDiv'
import RichEmail from './RichEmail'
import { richEditorListBlockDoc, richEditorDocAddBlocks } from './gestioneDatabase/Docs'
import { useStateContext } from '../context/StateContext'
import Divider from './frontend_components/Divider'
import TextField from './TextField'
import { RxUpdate } from "react-icons/rx";
import FieldDropdown from './FieldDropdown'
import TrueFalseToggle from './TrueFalseToggle'
import { UserEmailPin } from './management/ReportAperturaEmail'
import Swal from 'sweetalert2'
import { useAuthContext } from '../hooks/useAuthContext'

const TodaySevereComms = () => {

    const {
        sUser,
        customer,
        customerUsers,
        LDB,
        apiUrl
    } = useStateContext();

    const fetchRoute = `${apiUrl}/calls/fetch-docs`
    const {user} = useAuthContext()

      const customerId = sUser?.customer._ref
      const [days, setDays] = useState(1)
      const [updateDays, setUpdateDays] = useState(1)
      const [client, setClient] = useState()
      const [emailType, setEmailType] = useState("pec")

    const {data: nonConformities, isLoading: nonConformitiesLoading} = useQuery(['nonConformities'], ()=>_FETCH({route: fetchRoute, user, query: severeNonConformitiesQuery()}),{
       //staleTime: 1000 * 60 * 60,
       // cacheTime:  1000 * 60 * 60,
        onError:(error)=>{
            console.log("nonConformities not loaded", error);
            errorAlert("NON CONFORMITà NON CARICATE, RIPROVARE")
        },
    })

      const {data: registers, isLoading: registersLoading} = useQuery(['registers', days], ()=> _FETCH({route: fetchRoute, user, query: todayRegistersQuery(days)}),{
        staleTime: 1000 * 60 * 60,
        cacheTime:  1000 * 60 * 60,
        onError:(error)=>{console.log("registers", error)},

      })
      const sitesIds = (registers) => !Array.isArray(registers ) ? [] : registers?.map?.((register)=>`"${register?.site?._ref}"`)

    const {data: sites, isLoading: sitesLoading} = useQuery(['sites', registers], ()=> _FETCH({route: fetchRoute, user, query: sitesQueryByIds(sitesIds(registers))}),{
        enabled: !!sitesIds(registers)?.length > 0  && !!registers,
        staleTime: 1000 * 60 * 60,
        cacheTime:  1000 * 60 * 60,
        //onSuccess:(data)=>{console.log("sites", data)},
        onError:(error)=>{console.log("sites", error)},

      })
      const clientsIds = (sites) => !Array.isArray(sites) ? [] : sites?.map?.((site)=>`"${site?.client?._ref}"`)

      const {data: clients, isLoading: clientsLoading} = useQuery(['clients', sites], ()=> _FETCH({route: fetchRoute, user, query: clientsQueryByIds(clientsIds(sites))}),{
        enabled: !!clientsIds(sites)?.length > 0  && !!sites,
        staleTime: 1000 * 60 * 60,
        cacheTime:  1000 * 60 * 60,
        onError:(error)=>{console.log("clients", error)},

      }) 


      const {data: emailTemplates, isLoading: emailTemplatesLoading} = useQuery(['emailTemplates'], ()=>_FETCH({route: fetchRoute, user, query: emailTemplatesQuery(customerId)}),{
          enabled: !!customerId,
          //staleTime: 1000 * 60 * 60,
          //cacheTime:  1000 * 60 * 60,
          onError:(error)=>{console.log("email templates not loaded", error)},
      })


      const loadingQueries = [
        sitesLoading,
        registersLoading,
        clientsLoading,
        emailTemplatesLoading,
        nonConformitiesLoading
      ]
      const isQueriesLoading = loadingQueries?.some?.((x)=>x==true)

      const now = Date.now()
      const daysBefore = now - (1000*60*60*24*days)
    
    const arrayExists = (array) => {
        return array?.length > 0 ? array : []
    }   

    const severeComments = (register) => {
        const devices = register?.devices
        const comments = !Array.isArray(devices) ? [] : devices?.map?.((device)=>{

            const severeComments = !Array.isArray(device?.comments) ? [] : device?.comments?.filter?.((x)=>x?.severeOn < now && x?.severeOn > daysBefore )
                ?.map?.((comment)=>{
                    const siteId = register?.site?._ref
                    const findSite = !Array.isArray(sites) ? undefined : sites?.find?.((x)=>x?._id == siteId)
                    const clientId = findSite?.client?._ref
                    const registerId = register?._id

                    const siteLabel= findSite?.label
                    const registerLabel = register?.label
                    const deviceLabel = device?.label
                    const position = positionNumber(device)
                   //  ${}
                    const string = () =>{
                        return `NEL PLESSO ${siteLabel}, IL REGISTRO ${registerLabel}, PRESIDIO ${deviceLabel} POSIZIONE ${position} CONTIENE UN COMMENTO GRAVE: ${comment?.comment}`
                    } 

                    const doc = { 
                        siteId, 
                        clientId,
                        siteLabel,
                        registerId,
                        registerLabel,
                        deviceLabel,
                        position, 
                        string: string()
                       //device
                    }
                    return doc
                })

            return severeComments
        })
        return !Array.isArray(comments) ? [] : comments?.filter?.(x=>x?.length > 0 )?.flat()
    }
    const severeNonConformities = (register) => {
        const devices = register?.devices
        const deviceNonConformities = !Array.isArray(devices) ? [] : devices?.map?.((device)=>{

            const severeNonConformities = !Array.isArray(device?.nonConformities) ? [] : device?.nonConformities?.filter?.((x)=>x?.createdOn < now && x?.createdOn > daysBefore )
                ?.map?.((deviceNonConformity)=>{
                    const siteId = register?.site?._ref
                    const findSite = !Array.isArray(sites) ? undefined : sites?.find?.((x)=>x?._id == siteId)
                    const clientId = findSite?.client?._ref
                    const registerId = register?._id
                    const findNonConformity = !Array.isArray(nonConformities) ? undefined : nonConformities?.find?.((x)=>x?._id == deviceNonConformity?.nonConformity?._ref)

                    const siteLabel= findSite?.label
                    const registerLabel = register?.label
                    const deviceLabel = device?.label
                    const position = positionNumber(device)
                   //  ${}
                    const string = () =>{
                        return `NEL PLESSO ${siteLabel}, IL REGISTRO ${registerLabel}, PRESIDIO ${deviceLabel} POSIZIONE ${position} CONTIENE UNA NON CONFORMITA' GRAVE: ${findNonConformity?.label}`
                    } 

                    const doc = {
                        siteId, 
                        clientId,
                        siteLabel,
                        registerId,
                        registerLabel,
                        deviceLabel,
                        position, 
                        string: string()
                       //device
                    }
                    return findNonConformity && doc
                })?.filter?.((x)=>x)

            return severeNonConformities
        })
        return !Array.isArray(deviceNonConformities) ? [] : deviceNonConformities?.filter?.(x=>x?.length > 0 )?.flat()
    }
    const severeMotivations = (register) => {
        const devices = register?.devices

        const substituteReasons = !Array.isArray(devices) ? [] : devices?.map?.((device)=>{
            const reason = device?.substituteReason
            const updated = reason?._updatedAt && new Date(reason?._updatedAt)?.getTime();
            const created = reason?._createdAt && new Date(reason?._createdAt)?.getTime();
            const reasonDate = updated ? updated : created
            //if(reason?.notification) console.log("REASON", reason)
            if(reasonDate < now && reasonDate > daysBefore && reason?.notification){
                const siteId = register?.site?._ref
                const findSite = !Array.isArray(sites) ? undefined : sites?.find?.((x)=>x?._id == siteId)
                const clientId = findSite?.client?._ref
                const registerId = register?._id

                const siteLabel= findSite?.label
                const registerLabel = register?.label
                const deviceLabel = device?.label
                const position = positionNumber(device)
               //  ${}
                const string = () =>{
                    return `NEL PLESSO ${siteLabel}, IL REGISTRO ${registerLabel}, PRESIDIO ${deviceLabel} POSIZIONE ${position} CONTIENE UNA MOTIVAZIONE DI SOSTITUZIONE GRAVE: ${reason?.label}`
                } 

                const doc = { 
                    siteId, 
                    clientId,
                    siteLabel,
                    registerId,
                    registerLabel,
                    deviceLabel,
                    position, 
                    string: string()
                   //device
                }
                return doc
            }

        })
        return substituteReasons
    }
    const severeData = (registers) => {
        //console.log(registers)
        const data = !Array.isArray(registers) ? [] : registers?.map?.((register)=>{
            const comments = arrayExists(severeComments(register))
            const nonConformities = arrayExists(severeNonConformities(register))
            const motivations = arrayExists(severeMotivations(register))
            return [...nonConformities, ...comments, ...motivations]?.filter?.((x=>x))
        })?.flat()

        return data
    } 
    const emailDataList = (severeData) => {
        const data = !Array.isArray(severeData) ? [] : severeData?.map?.((data)=>(!data ? {} : {...data, listBlock: richEditorListBlockDoc(data?.string) }))
        return data
    }

    // EMAIL TEMPLATE BLOCKS TRANSLATION
   
    
    const emailData = {
        companyName: customer?.name ? customer?.name : "",
        companyEmail: customer?.email ? customer?.email : "",
        companyAddress: siteAddress(customer),
        companyPhoneNumber: customer?.phoneNumber ? customer?.phoneNumber : "",
        userFirstName: sUser?.firstName ? sUser?.firstName : "",
        userLastName: sUser?.lastName ? sUser?.lastName : ""
    }
    //console.log("snjasxcjaskjxansx", sUser)


  
   
    const emailDoc = (client, registers, recipient) =>{ 
        
        const userData = {
            recipientLastName: recipient?.lastName ? recipient?.lastName : "",
            recipientProfessionalTitle: recipient?.professionalTitle ? recipient?.professionalTitle : "",
        }
        const emailDataWithUser = {...emailData, ...userData}
        const signatureRichDoc = emailTemplates?.[0]?.emailSignature
        const convertedSignatureRichDoc = convertRichEditorDynamicData(signatureRichDoc, emailDataWithUser)
        const notificationRichDoc = emailTemplates?.[0]?.severeNotifications
        const convertedNotificationRichDoc = convertRichEditorDynamicData(notificationRichDoc, emailDataWithUser)

        const clientSevereData = severeData(registers)
        
        const severeList = emailDataList(clientSevereData)?.map?.((item=>item?.listBlock))

        const editorBlocks = [
            ...convertedNotificationRichDoc,
            ...severeList, 
            ...convertedSignatureRichDoc
            ]
        //console.log("ndskjcnkjdnc", editorBlocks)

        const doc = {
            subject: `SEGNALAZIONE GRAVI NON CONFORMITA' SICUREZZA ANTINCENDIO`,
            //htmlBody: "",
            richEditorObj:richEditorDocAddBlocks(editorBlocks),
            text: "",
            toEmail: recipient?.email,
            sender: customer?.name ? customer?.name : "RelyOn",
            replyTo: customer?.email,
            //clientSevereData, 
            //registers
        }
        const pec = {
            subject: `SEGNALAZIONE GRAVI NON CONFORMITA' SICUREZZA ANTINCENDIO`,
            //htmlBody: "",
            richEditorObj:richEditorDocAddBlocks(editorBlocks),
            text: "",
            toEmail: recipient?.email,
            //sender: customer?.name ? customer?.name : "RelyOn",
            //replyTo: customer?.email,
            //clientSevereData, 
            //registers
        }
        return emailType == "pec" ? pec : doc
    }

    const allSevereData = severeData(registers)
    const clientsWithSevereData = !Array.isArray(clients) ? [] : clients?.filter?.((x)=>allSevereData?.some?.((y)=>y?.clientId == x?._id))
    const testFunction = () => {

        console.log("severe data","hbduywehde", clientsWithSevereData)
    }

    if(isQueriesLoading){return <Loading/>}
  return (
    <div>
        <h2 style={{marginBottom:"10px"}} onClick={testFunction} >NOTIFICHE GRAVI</h2>
        <div style={{width:"50%", display:"flex", alignItems:"center"}}>
            <TextField 
                value={updateDays} 
                type={"number"}
                label={"GIORNI DA VISUALIZZARE"}
                onChange={(e) => setUpdateDays(e.target.value)} 
                descriptionDivider={false}
            />
            <VisDiv rules={[Number(updateDays) !== days]} className='round-back-button' style={{backgroundColor:"green", marginLeft:"15px"}} onClick={(e) => {setDays(Number(updateDays))}}> 
                <RxUpdate fontSize={20} color="white" />
            </VisDiv>
        </div>
        <h4>FILTRI:</h4>
        <FieldDropdown
                isSearchable="isSearchable"
                placeHolder={LDB("misc", "selectClient")}
                options={addValueForDropdown(clientsWithSevereData)?.sort(sortByLabel)}
                onChange={(value) => {setClient(value)}
                }
            />  
        <div style={{display:"flex", alignItems:"center"}}>
            <h4 style={{marginRight:"10px"}}>EMAIL</h4>
            <TrueFalseToggle
                value={emailType == "pec" ? true : false}
                onClick={()=>{
                    emailType == "pec" ? setEmailType("email") : setEmailType("pec")
                }
                }
                //description={emailType == "pec" ? "Spedisci Pec" : "Spedisci E-mail"}
            />
            <h4 style={{marginLeft:"10px"}}>PEC</h4>
        </div>
        {emailType == "pec" ? "Spedisci Pec" : "Spedisci E-mail"}
        <Divider bottom={"10px"}/>   
        {!Array.isArray(clientsWithSevereData) ? [] : clientsWithSevereData?.filter?.((x)=> client ? x?._id == client?._id : x )?.map?.((client)=>{
            const severeNonConformitiesToScreen = () => (<div>
                    {!Array.isArray(clientSites) ? [] : clientSites?.map?.((site)=>{
                    return(
                        <div key={site?._id} style={{marginLeft:"30px"}}>
                        {/* {site?.label}  */}
                        {!Array.isArray(registers) ? [] : registers?.filter?.((x)=>x?.site?._ref == site?._id)?.map?.((register)=>{
                            const comments = severeComments(register)
                            const foundSevereNonConformities = severeNonConformities(register)
                            const foundSevereMotivations = severeMotivations(register)
                            const testRegister = () => {
                                console.log("REGISTER", register)
                            }
                            return(
                                <VisDiv key={register?._id} rules={[comments?.length > 0 || foundSevereNonConformities?.length > 0]} style={{marginLeft:"10px"}} onClick={testRegister}>                                 
                                    {!Array.isArray(comments) ? [] : comments?.map?.((comment, index)=><p key={index}>{comment?.string}</p>)}
                                    {!Array.isArray(foundSevereNonConformities) ? [] : foundSevereNonConformities?.map?.((nc, index)=><p  key={index} >{nc?.string}</p>)}
                                    {!Array.isArray(foundSevereMotivations) ? [] : foundSevereMotivations?.map?.((motivation, index)=><p  key={index} >{motivation?.string}</p>)}
                                </VisDiv>
                            )
                        })}
                        </div>   
                    )
                })}
            </div>)
            const clientPec = client?.pec
            const clientSites = !Array.isArray(sites) ? [] : sites?.filter?.(x=>x?.client?._ref == client?._id)
            const clientRegisters = !Array.isArray(registers) ? [] : registers?.filter?.(x=>clientSites?.some?.((y)=>x?.site?._ref == y?._id))
            const users = customerUsers?.filter?.((x)=>x?.assignedClients?.some?.((y)=>y?._ref == client?._id))
            const emails = !Array.isArray(users) ? [] : users?.map?.((user)=>(emailDoc(client, clientRegisters, user)))
            const pec = emailDoc(client, clientRegisters, {email: clientPec})

            const testClientFunction = () => {
                console.log("dgyuegduy", emails, pec)
            }
            if(emailType == "pec"){
                if(!clientPec) return (
                    <div>
                        <h2>{client?.label} NON CI SONO PEC PRESENTI</h2>
                        {severeNonConformitiesToScreen()}

                        <Divider bottom={"20px"}/>
                    </div>
                )
                return (
                    <div key={client?._id}>
                        <h2 onClick={testClientFunction}>{client?.label}</h2>
                        <RichEmail clients={clients} service={"aruba"} emailType={"pec"} emailTemplate={pec}/>
                        <UserEmailPin title={"COMUNICAZIONI"} index={1} client={client} user={client}/>
                        <Divider bottom={"20px"}/>
                    </div>)
            } 
            if(emailType == "email"){
                if(users?.length < 1) return (
                    <div>
                          <h2>{client?.label} NON CI SONO UTENTI PRESENTI</h2>
                          {severeNonConformitiesToScreen()}
                        <Divider bottom={"20px"}/>
                    </div>
                )
                return (
                <div key={client?._id}>
                    <h2 onClick={testClientFunction}>{client?.label}</h2>
                    <RichEmail emailTemplate={emails?.[0]}/>
                    <Divider bottom={"20px"}/>
                </div>)
            }

        })}
    </div>
  )
}

export default TodaySevereComms
